import { render, staticRenderFns } from "./SwiperItem.vue?vue&type=template&id=7e508300&scoped=true&"
import script from "./SwiperItem.vue?vue&type=script&lang=js&"
export * from "./SwiperItem.vue?vue&type=script&lang=js&"
import style0 from "./SwiperItem.vue?vue&type=style&index=0&id=7e508300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e508300",
  null
  
)

export default component.exports